import React, { useState } from "react";

import Icono from "./iconos/IconosHeliCalc.jsx";
import { nombreDePerfil } from "../domain/identidad.js";
import { forzarActualizacion, sePuedeForzar } from "../services/actualizacion.js";

/* Lo inyecta vite.config.js al compilar. El respaldo cubre los tests. */
const SELLO = typeof __SELLO_BUILD__ === "string" ? __SELLO_BUILD__ : "desarrollo";

/**
 * Aviso permanente exigido por el pliego: ni la matriz de riesgo ni los
 * cálculos de performance son certificación oficial.
 *
 * Se puede contraer, pero no cerrar: colapsado sigue mostrando una línea
 * visible. Un aviso que el usuario puede hacer desaparecer para siempre no
 * cumple la función para la que existe.
 */
export default function DisclaimerBar({
  alAdministrar,
  alVolver = null,
  usuario = null,
  alSalir = null,
}) {
  const [expandido, setExpandido] = useState(false);
  const [forzando, setForzando] = useState(false);

  return (
    <div className="hc-bar hc-bar--disclaimer" role="note">
      <span aria-hidden="true">⚠</span>
      {expandido ? (
        <div>
          <strong>Herramienta de apoyo a la decisión. No es documento certificado.</strong>
          <p style={{ margin: "6px 0 0", color: "#E8D9BC" }}>
            Los cálculos de performance, peso y balance, combustible y riesgo son estimaciones
            basadas en cartas digitalizadas y fórmulas estándar. <strong>No reemplazan el RFM
            (manual de vuelo) certificado del fabricante</strong>, ni la documentación aprobada
            de la aeronave, ni el criterio de la autoridad aeronáutica correspondiente (FAA,
            DGAC Perú, DGAC Ecuador o DGAC Chile). Verifique todo dato crítico contra la fuente
            oficial antes de operar.
          </p>
        </div>
      ) : (
        <span>
          Apoyo a la decisión — <strong>no reemplaza el RFM</strong> ni a la autoridad
          aeronáutica.
        </span>
      )}
      <span className="hc-bar__spacer" />
      <button
        type="button"
        className="hc-btn hc-no-print"
        onClick={() => setExpandido((v) => !v)}
        aria-expanded={expandido}
      >
        {expandido ? "Contraer" : "Leer aviso"}
      </button>

      {/* Sello de compilación SIEMPRE a la vista.

          Durante ocho rondas el iPad sirvió una versión vieja desde su caché y
          no había forma de saberlo desde una captura: se corregía, se
          entregaba, y el dispositivo mostraba lo de antes. Ahora cualquier foto
          de la pantalla dice qué versión está corriendo.

          Tocarlo borra la copia guardada y recarga, para cuando la caché queda
          atascada igual. */}
      <button
        type="button"
        className="hc-sello"
        onClick={async () => {
          if (!sePuedeForzar()) return;
          setForzando(true);
          await forzarActualizacion();
        }}
        title="Versión en uso. Tocar para descargar la última y recargar."
      >
        {forzando ? "actualizando…" : SELLO}
      </button>

      {/* ═══ ADMINISTRACIÓN, ARRIBA A LA DERECHA ═══

          Acá y no en la lista de herramientas: no es una herramienta de vuelo,
          es la puerta a la empresa, los usuarios y los perfiles. En el riel
          quedaba DUPLICADA —el riel la muestra cuando entra, el cajón «Todas»
          cuando no— y a 883 px, que es un iPad en horizontal, directamente no
          se veía.

          Va última, pegada al borde derecho y con el alto de la barra: no
          empuja nada ni hace crecer el aviso legal, que ya ocupa lo justo.

          Cuando exista la entrada (e133), este botón pasa a ser el menú del
          usuario: hoy dice «Administración»; después va a decir con quién estás
          adentro y va a tener «Cerrar sesión». */}
      {/* ═══ CON QUIÉN ESTÁS ADENTRO ═══

          El nombre y la salida viven acá porque esta barra está a la vista en
          TODAS las pantallas. En el riel no: a 883 px —un iPad en
          horizontal— el riel está oculto, y cerrar sesión habría quedado en un
          menú que no se ve.

          El perfil va en el `title` y no en el texto: en una barra de 33 px el
          nombre ya ocupa lo justo, y el perfil completo lo haría crecer. */}
      {usuario && (
        <span
          className="hc-bar__usuario hc-no-print"
          title={`${usuario.nombre} · ${nombreDePerfil(usuario.perfil)}${usuario.empresa ? ` · ${usuario.empresa}` : ""}`}
        >
          {usuario.nombre}
        </span>
      )}

      {alAdministrar ? (
        <button type="button" className="hc-btn hc-no-print hc-bar__admin" onClick={alAdministrar}>
          <Icono nombre="empresa" tam={14} />
          <span>Administración</span>
        </button>
      ) : null}

      {/* ═══ VOLVER A GESTIÓN ═══

          Aparece solo si se llegó acá desde gestión —lo decide el cascarón, que
          es quien sabe por qué vista se entró—. Al piloto no se le muestra un
          botón de «volver» a una pantalla que nunca vio, y al administrador de
          empresa sí: es el camino de vuelta de la puerta que abrió. */}
      {alVolver ? (
        <button type="button" className="hc-btn hc-no-print hc-bar__admin" onClick={alVolver}>
          <Icono nombre="empresa" tam={14} />
          <span>Volver a gestión</span>
        </button>
      ) : null}

      {usuario && alSalir ? (
        <button type="button" className="hc-btn hc-no-print" onClick={alSalir}>
          Salir
        </button>
      ) : null}
    </div>
  );
}
